<template>
  <v-container class="calendar">
    <!-- HEADER -->
    <div class="scroll">
      <v-row no-gutters class="calendar-header flex-nowrap">
        <v-col cols="2" sm="1" v-if="$vuetify.breakpoint.smAndUp"></v-col>
        <v-col
          cols="4"
          sm=""
          v-for="day in weekdays"
          :key="day.date"
          class="d-flex justify-center text-overline font-weight-regular text--secondary"
          style="border-left: 1px solid rgb(226, 226, 226)"
        >
          {{ day.value }}
          <span :v-if="day.date" style="margin-left: 8px">
            {{ day.date | Day }}</span
          >
        </v-col>
      </v-row>

      <!-- BODY -->
      <v-row
        no-gutters
        v-for="slot in timeslots"
        :key="slot"
        class="calendar-body flex-nowrap"
      >
        <v-col
          v-if="$vuetify.breakpoint.smAndUp"
          cols="2"
          sm="1"
          class="d-flex justify-center text-overline font-weight-regular align-center text--secondary"
          style="border-top: 1px solid rgb(226, 226, 226)"
        >
          {{ slot }}
        </v-col>
        <v-col
          cols="4"
          sm=""
          v-for="day in weekdays"
          :key="day.date"
          class="calendar-interval"
        >
          <!-- Events-->
          <Event
            v-for="session in getSlotSessions(
              slot,
              sessions[day.text]
            )"
            :key="session.id"
            :session="session"
            :tutor="getTutorById(session.tutor)"
            :capacity="capacities[session.tutorial]"
          ></Event>
        </v-col>
      </v-row>
    </div>
    <!-- Farblegende -->
    <v-row
      class="d-flex justify-center align-center calendar-legend text-caption font-weight-light"
    >
      <v-chip
        color="#64A0C8"
        label
        x-small
        :ripple="false"
        class="mr-1"
      ></v-chip>
      <v-chip
        color="#3D82AF"
        label
        x-small
        :ripple="false"
        class="mr-1"
      ></v-chip>
      <v-chip
        color="#2D5E7F"
        label
        x-small
        :ripple="false"
        class="mr-1"
      ></v-chip>
      <v-chip
        color="#22475F"
        label
        x-small
        :ripple="false"
        class="mr-1"
      ></v-chip>
      <div>Belegung</div>
      <v-chip
        color="#E99A27"
        label
        x-small
        :ripple="false"
        class="mr-1 ml-5"
      ></v-chip>
      <div>Modifiziert</div>
      <v-chip
        color="#E47B73"
        label
        x-small
        :ripple="false"
        class="mr-1 ml-5"
      ></v-chip>
      <div>Abgesagt</div>
      <v-chip
        color="#8a8989"
        label
        x-small
        :ripple="false"
        class="mr-1 ml-5"
      ></v-chip>
      <div>Programmier-Fragestunde</div>
    </v-row>
  </v-container>
</template>

<style scoped>
.calendar-header {
  min-height: 50px;
}

.calendar-body {
  min-height: 100px;
}

.calendar-interval {
  border-top: 1px solid rgb(226, 226, 226);
  border-left: 1px solid rgb(226, 226, 226);
}

.calendar-legend {
  margin-top: 2rem;
}

.scroll {
  overflow-y: scroll;
}
</style>

<script>
import Event from "@/components/Event.vue";

export default {
  name: "Calendar",
  props: ["week", "sessions", "tutors", "capacities"],
  components: {
    Event,
  },
  data: function () {
    return {
      weekdays: [
        {
          text: "Mo",
          value: "Mon",
          date: this.getDateInWeek("Mo"),
        },
        {
          text: "Di",
          value: "Tue",
          date: this.getDateInWeek("Di"),
        },
        {
          text: "Mi",
          value: "Wed",
          date: this.getDateInWeek("Mi"),
        },
        {
          text: "Do",
          value: "Thu",
          date: this.getDateInWeek("Do"),
        },
        {
          text: "Fr",
          value: "Fri",
          date: this.getDateInWeek("Fr"),
        },
      ],
      timeslots: ["08:00", "10:00", "12:00", "14:00", "16:00"],
    };
  },
  watch: {
    week: function () {
      for (let i = 0; i < this.weekdays.length; i++) {
        this.weekdays[i].date = this.getDateInWeek(this.weekdays[i].text);
      }
    },
  },
  methods: {
    getDateInWeek(weekday) {
      switch (weekday) {
        case "Mo":
          return this.week;
        case "Di":
          return this.addDays(new Date(this.week), 1);
        case "Mi":
          return this.addDays(new Date(this.week), 2);
        case "Do":
          return this.addDays(new Date(this.week), 3);
        case "Fr":
          return this.addDays(new Date(this.week), 4);
      }
    },
    addDays(date, days) {
      date.setDate(date.getDate() + days);
      const dateString = date.toISOString();
      const dateArray = dateString.split("T");
      return dateArray[0];
    },
    getSlotSessions(slot, sessions) {
      if (!sessions) {
        return [];
      }
      // return sessions.filter((s) => {
      //   return s.start == slot;
      // });
      const slotHour = parseInt(slot.substring(0,2));
      const slotSessions = sessions.filter((s) => {
        return [slotHour, slotHour + 1].includes(parseInt(s.start.substring(0,2)));
      });
      return this.sortSlotSessionsByCapacity(slotSessions);
    },
    sortSlotSessionsByCapacity(sessions) {
      return sessions.sort((a, b) => {
        const capA = this.capacities[a.tutorial].capacity;
        const capB = this.capacities[b.tutorial].capacity;
        return this.compareCapacities(capA, capB);
      });
    },
    compareCapacities(a, b) {
      const caps = ["NOT_CROWDED", "NORMAL", "CROWDED", "BUSY"];
      const indexA = caps.indexOf(a);
      const indexB = caps.indexOf(b);
      if (indexA === -1 || indexB === -1) return 0;
      return indexA - indexB;
    },
    getTutorById(id) {
      const tutor = this.tutors.find((e) => e.id == id);
      if (tutor) {
        if (tutor.firstName) {
          return tutor.firstName.split(" ")[0];
        } else {
          return tutor.username;
        }
      }
      return "";
    },
  },
  filters: {
    // Filter definitions
    Day(value) {
      const dateArray = value.split("-");
      if (dateArray.length >= 3) {
        return dateArray[2];
      }
      return "";
    },
  },
};
</script>
